module.exports = __webpack_public_path__ + "img/avatar2.f6b1891a.png";